module.exports = __webpack_public_path__ + "img/game_main_pc_26_off.060f3772.png";